import { makeStyles } from "tss-react/mui"
import { blueGrey } from "../../../../mp-core/themes/palette"

export const useStyles = makeStyles()(({ breakpoints, spacing, palette }) => ({
  root: {
    width: "100vw",
    marginLeft: `min(calc((${breakpoints.values.xl}px - 100vw) / 2) , 0px)`,
    padding: spacing(3, 6),
    borderBottom: `1px solid ${blueGrey[100]}`,
    backgroundColor: palette.common.white
  }
}))
